import calculateScheduledDistribution, {
  clearScheduledDistributionMemo,
} from '../../Impounds/helpers/calculateScheduledDistribution';

// Calculated Balance, Value: First row formula should be {Initial Impound Balance} + {Total Monthly Impound Payment) - {Distribution total for row}. Second row and beyond should be {calculated balance from the previous row} + {Total Monthly Impound Payment) - {Distribution total for row}
export default function getCalculatedBalance({
  invoices,
  startingInvoiceIndex,
  initialImpoundBalance,
  totalMonthlyImpoundPayment,
  bills,
}) {
  const twelveMonthsInvoices = invoices.slice(
    startingInvoiceIndex,
    startingInvoiceIndex + 12
  );

  let prevValue = initialImpoundBalance;
  const calculatedBalances = twelveMonthsInvoices.map((invoice) => {
    const { sum: distribution } = calculateScheduledDistribution({
      row: invoice,
      bills,
      shouldReturnRawValue: true,
    });

    const value = prevValue + +totalMonthlyImpoundPayment - distribution;
    prevValue = value;
    return value.toFixed(2);
  });

  clearScheduledDistributionMemo();

  return calculatedBalances;
}
